import { useMediaQuery } from '@mui/material'
import { useSelector } from 'react-redux'

import { themeSelector } from '@/store/themeSlice'

function useIsDark() {
  const { mode } = useSelector(themeSelector)
  const mq = useMediaQuery('(prefers-color-scheme: dark)')
  const prefersDarkMode = mode === 'dark' || (mode === 'unset' && mq)

  return prefersDarkMode
}

export default useIsDark
